/**
 * Created by Ning Jiang on 4/27/2016.
 */

import {AvalancheParsedInitData} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/AvalancheParsedServerData";
import {IFITHInitData} from "./IFITHServerData";
import {FITHServerDataParser} from "../FITHServerDataParser";
import {
    FeatureBuyTimesBetValue
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export class FITHParsedInitData extends AvalancheParsedInitData {
    private readonly _activeRowsOpenedEnteringBonus: number;
    private readonly _bottomCollectorActivated: boolean[];
    private readonly _bonusValues: number[][];
    private readonly _openPositionsBonus: boolean[][];
    private readonly _bonusWinTimesBet: number;
    private readonly _totalNumberOfWays: string;
    private readonly _activeRows: number;
    private readonly _wasFeatureBuy: boolean;
    private readonly _featureBuyTimesBetValue: FeatureBuyTimesBetValue[];

    constructor(rawData: IFITHInitData, dataParser: FITHServerDataParser) {
        rawData.reels = dataParser.parseReelData(rawData);
        rawData.reelsAfterCollapse = dataParser.parseReelsAfterCollapseData(rawData);

        super(rawData, dataParser);

        this._activeRowsOpenedEnteringBonus = dataParser.parseActiveRowsOpenedEnteringBonus(rawData);
        this._bottomCollectorActivated = dataParser.parseBottomCollectorActivated(rawData);
        this._bonusValues = dataParser.parseBonusValues(rawData);
        this._openPositionsBonus = dataParser.parseOpenPositionsBonus(rawData);
        this._bonusWinTimesBet = dataParser.parseBonusWinTimesBet(rawData);
        this._activeRows = dataParser.parseActiveRows(rawData);
        this._totalNumberOfWays = dataParser.parseTotalNumberOfWays(rawData);
        this._wasFeatureBuy = rawData.wasFeatureBuy;
        this._featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
    }

    get featureBuyTimesBetValue(): FeatureBuyTimesBetValue[] {
        return this._featureBuyTimesBetValue;
    }

    get wasFeatureBuy(): boolean {
        return this._wasFeatureBuy;
    }

    get activeRowsOpenedEnteringBonus(): number {
        return this._activeRowsOpenedEnteringBonus;
    }

    get bottomCollectorActivated(): boolean[] {
        return this._bottomCollectorActivated;
    }

    get bonusValues(): number[][] {
        return this._bonusValues;
    }

    get openPositionsBonus(): boolean[][] {
        return this._openPositionsBonus;
    }

    get bonusWinTimesBet(): number {
        return this._bonusWinTimesBet;
    }

    get totalNumberOfWays(): string {
        return this._totalNumberOfWays;
    }

    get activeRows(): number {
        return this._activeRows;
    }

    protected isFeatureTotalWin(): boolean {
        return true;
    }
}